import { render } from "./BaseAgenda.vue?vue&type=template&id=3d73b72c"
import script from "./BaseAgenda.vue?vue&type=script&lang=js"
export * from "./BaseAgenda.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/arda/arda-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__